module.exports = __webpack_public_path__ + "img/title.de44370e.png";